import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-list-view-large.tsx
/**
* icon.24.list-view.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTUuNSAxN2ExLjUgMS41IDAgMSAxIDAgMyAxLjUgMS41IDAgMCAxIDAtM20wIDFhLjUuNSAwIDEgMCAwIDEgLjUuNSAwIDAgMCAwLTFtMTQgMGEuNS41IDAgMCAxIDAgMWgtMTBhLjUuNSAwIDAgMSAwLTF6bS0xNC03LjVhMS41IDEuNSAwIDEgMSAwIDMgMS41IDEuNSAwIDAgMSAwLTNtMCAxYS41LjUgMCAxIDAgMCAxIC41LjUgMCAwIDAgMC0xbTE0IDBhLjUuNSAwIDAgMSAwIDFoLTEwYS41LjUgMCAwIDEgMC0xek01LjUgNGExLjUgMS41IDAgMSAxIDAgMyAxLjUgMS41IDAgMCAxIDAtM20wIDFhLjUuNSAwIDEgMCAwIDEgLjUuNSAwIDAgMCAwLTFtMTQgMGEuNS41IDAgMCAxIDAgMWgtMTBhLjUuNSAwIDAgMSAwLTF6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26677-58941
*/
const Icon24ListViewLarge = memo(function Icon24ListViewLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M5.5 17a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m14 0a.5.5 0 0 1 0 1h-10a.5.5 0 0 1 0-1zm-14-7.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m14 0a.5.5 0 0 1 0 1h-10a.5.5 0 0 1 0-1zM5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m14 0a.5.5 0 0 1 0 1h-10a.5.5 0 0 1 0-1z"
		})
	});
});
//#endregion
export { Icon24ListViewLarge };

//# sourceMappingURL=icon-24-list-view-large.js.map